module.exports = __webpack_public_path__ + "static/media/property.ab335632.svg";